export default [
  {
    featureType: "all",
    elementType: "all",
    stylers: [
      {
        saturation: -20
      },
      {
        gamma: 0.36
      }
    ]
  },
  {
    featureType: "all",
    elementType: "geometry",
    stylers: [
      {
        color: "#f5f5f5"
      },
      {
        visibility: "simplified"
      }
    ]
  },
  {
    featureType: "all",
    elementType: "labels",
    stylers: [
      {
        textfill: "#616161"
      },
      {
        textoutline: "#f5f5f5"
      },
      {
        icon: "hidden"
      }
    ]
  },
  {
    featureType: "poi",
    elementType: "geometry",
    stylers: [
      {
        color: "#eeeeee"
      },
      {
        visibility: "simplified"
      }
    ]
  },
  {
    featureType: "poi",
    elementType: "labels",
    stylers: [
      {
        textfill: "#757575"
      },
      {
        visibility: "simplified"
      }
    ]
  },
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [
      {
        textfill: "#e5e5e5"
      },
      {
        visibility: "simplified"
      }
    ]
  },
  {
    featureType: "poi.park",
    elementType: "labels",
    stylers: [
      {
        textfill: "#9e9e9e"
      },
      {
        visibility: "simplified"
      }
    ]
  },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [
      {
        visibility: "inherit"
      },
      {
        color: "#ffffff"
      }
    ]
  },
  {
    featureType: "road.highway",
    elementType: "geometry",
    stylers: [
      {
        visibility: "inherit"
      },
      {
        color: "#dadada"
      }
    ]
  },
  {
    featureType: "road.highway",
    elementType: "labels",
    stylers: [
      {
        textfill: "#616161"
      },
      {
        visibility: "inherit"
      },
      {
        icon: "hidden"
      }
    ]
  },
  {
    featureType: "road.arterial",
    elementType: "geometry",
    stylers: [
      {
        textfill: "#757575"
      }
    ]
  },
  {
    featureType: "road.arterial",
    elementType: "labels",
    stylers: [
      {
        icon: "hidden"
      }
    ]
  },
  {
    featureType: "road.local",
    elementType: "labels",
    stylers: [
      {
        textfill: "#9e9e9e"
      },
      {
        icon: "hidden"
      }
    ]
  },
  {
    featureType: "transit",
    elementType: "all",
    stylers: [
      {
        visibility: "hidden"
      },
      {
        icon: "hidden"
      }
    ]
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [
      {
        color: "#b9e7f9"
      },
      {
        lightness: 45
      },
      {
        visibility: "simplified"
      }
    ]
  },
  {
    featureType: "water",
    elementType: "labels",
    stylers: [
      {
        textfill: "#9e9e9e"
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolMap/MapStyles.js